import { Box } from "theme-ui";

import PerformanceOptionField from "./PerformanceOptionField";
import * as styles from "./PerformanceOptions.styles";

export default function PerformanceOptions({ options, value, onChange }) {
  return (
    <Box sx={styles.optionsContainer}>
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <PerformanceOptionField
            key={option.value}
            isSelected={isSelected}
            option={option}
            heading={option.heading}
            subHeading1={option.subHeading1}
            subHeading2={option.subHeading2}
            bladeSegments={option.bladeSegments}
            onChange={onChange}
            label={option.label}
            value={option.value}
          />
        );
      })}
    </Box>
  );
}
